import {Component, Input} from '@angular/core';
import {WalkthroughModule} from './walkthrough.module';

import {ActivatedRoute, Router} from '@angular/router';
import {ROUTES} from '../../app.routes';
import {AssetPipeModule} from '../../sdk/pipe/assetPipeModule';

@Component({
    selector: 'app-product-walkthrough',
    templateUrl: './product-walkthrough.component.html',
    styleUrls: ['./product-walkthrough.component.scss'],
    imports: [
    WalkthroughModule,
    AssetPipeModule
]
})
export class ProductWalkthroughComponent
{
    steps = ['Step1', 'Step2', 'Step3', 'Step4', 'Step5', 'Step6'];
    currentStepIndex = 0;
    nextButtonText = 'Start';
    @Input() lastStepIndex: number;

    constructor(private router: Router, private route: ActivatedRoute)
    {
        this.lastStepIndex = this.route.data['value']['lastStepIndex'] ?? this.steps.length - 1;
    }

    nextStep()
    {
        if (this.currentStepIndex <= this.lastStepIndex)
        {
            if ((this.currentStepIndex + 1) <= this.lastStepIndex)
            {
                if ((this.currentStepIndex + 1) === this.lastStepIndex)
                {
                    this.nextButtonText = 'Done';
                }
                else
                {
                    this.nextButtonText = 'Next Tip';
                }
                this.currentStepIndex++;
            }
            else
            {
                // done was clicked
                this.router.navigate([ROUTES.SECURE.HOME.VIEW.path]).then();
            }
        }
    }

    skipWalkthrough()
    {
        this.router.navigate([ROUTES.SECURE.HOME.VIEW.path]).then();
    }
}